jQuery(document).ready(function() {
    const base = 'gc-file-upload';
    let dropArea = document.getElementById('drop-area');
    let fileInput = document.querySelector('input[type=file]');
    let filesList = document.querySelector(`.${base}__files`);

    if (dropArea && fileInput && filesList) {
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false);
        });

        ['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false);
        });

        dropArea.addEventListener('drop', handleDrop, false);

        fileInput.addEventListener('change', handleChange, false);
    } 

    function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function handleChange(e) {
        if (fileInput.files.length > 0) {
            Array.from(fileInput.files).forEach(file => {
                let fileElement = document.createElement('div');
                let fileContent = document.createTextNode(file.name);
                fileElement.appendChild(fileContent);
                filesList.appendChild(fileElement);
            });
        }
    }

    function handleDrop(e) {
        e.preventDefault();
        let files = e.dataTransfer.files;

        fileInput.files = files;
        handleChange();
	}

    function highlight(e) {
        dropArea.classList.add(`${base}--highlight`);
    }

    function unhighlight(e) {
        dropArea.classList.remove(`${base}--highlight`);
    }
});
